import { ProviderTranscriptionConsentModalConnected as BaseProviderTranscriptionConsentModalConnected } from '@grow-therapy-team/seedling-components';

import { ConsentUpdateSource } from '../../video-sdk/core/message/constants';
import { useProviderTranscriptionConsentModal } from './useProviderTranscriptionConsentModal';
import { useShowRefreshedTranscriptionConsentCopy } from './useShowRefreshedTranscriptionConsentCopy';

/**
 * Wrapper component that manages the modal display logic and connects the modal
 * to the orchestrating hook.
 */
export function ProviderTranscriptionConsentModalConnected() {
  const { isModalOpen, onClose, onDismiss, providerShortId } = useProviderTranscriptionConsentModal();
  const showRefreshedCopy = useShowRefreshedTranscriptionConsentCopy(providerShortId);

  if (!providerShortId) return null;

  return (
    <BaseProviderTranscriptionConsentModalConnected
      isOpen={isModalOpen}
      onClose={onClose}
      onDismiss={onDismiss}
      providerShortId={providerShortId}
      showRefreshedCopy={showRefreshedCopy}
      updateSource={ConsentUpdateSource.TELEHEALTH_WAITING_ROOM}
    />
  );
}
